var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('card', {
    attrs: {
      "to": _vm.$web('jobs.show', _vm.job._key),
      "height": _vm.height
    }
  }, [_vm.job.image ? _c('card-image', {
    attrs: {
      "src": _vm.job.image,
      "alt": _vm.job.title,
      "size": {
        width: 390,
        ratio: 4 / 2
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('card-title', {
    attrs: {
      "large": ""
    }
  }, [_vm._v(_vm._s(_vm._f("truncate")(_vm.job.title, 72)))]), _vm._v(" "), _c('card-subtitle', {
    attrs: {
      "x-small": ""
    }
  }, [_c('meta-text', [_vm._v(_vm._s(_vm.$t('label.start_date')) + " " + _vm._s(_vm.$date(_vm.job.start_date).format('LL')))])], 1), _vm._v(" "), _c('card-text', {
    staticClass: "text-truncate"
  }, [_vm._v(_vm._s(_vm.job.short_description))]), _vm._v(" "), _vm.job.category ? _c('card-subtitle', [_c('chip', {
    attrs: {
      "color": "primary",
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.job.category.name))])], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }